<div class="m-10 flex h-[100px] w-[120px] items-center justify-center rounded-lg bg-neutral-100 p-6 shadow-lg">
  <img
    class="h-full w-full object-contain"
    width="100"
    height="75"
    alt="Loading..."
    priority="true"
    [ngSrc]="'assets/gifs/loader.gif'"
  />
</div>
